import type { Sorting } from '@tbitop/ui';
import { SortDirection } from '@tbitop/ui';
import { isUndefined } from 'lodash-es';

type SortierkriteriumEnum = { Standard: 'STANDARD'; [key: string]: string };
type SortierkriteriumEnumValue<T extends SortierkriteriumEnum> = T[keyof T];

export const toSortierkriterium = <T extends string, SK extends SortierkriteriumEnum>(sorting: Sorting<T>, sortierkriteriumEnum: SK) => {
  return isUndefined(sorting[0]) ?
    sortierkriteriumEnum.STANDARD as SortierkriteriumEnumValue<SK> :
    sortierkriteriumEnum[sorting[0]];
};

type SortierrichtungEnum = { Aufsteigend: 'AUFSTEIGEND'; Absteigend: 'ABSTEIGEND' };
type SortierrichtungEnumValue<T extends SortierrichtungEnum> = T[keyof T];

export const toSortierrichtung = <SR extends SortierrichtungEnum>(sorting: Sorting<unknown>, sortierrichtungEnum: SR) => {
  if (sorting[1] === SortDirection.Ascending) {
    return sortierrichtungEnum.Aufsteigend as SortierrichtungEnumValue<SR>;
  }
  if (sorting[1] === SortDirection.Descending) {
    return sortierrichtungEnum.Absteigend as SortierrichtungEnumValue<SR>;
  }
  return sortierrichtungEnum.Aufsteigend as SortierrichtungEnumValue<SR>;
};
